import { render } from "./IssueBox.vue?vue&type=template&id=46421362"
import script from "./IssueBox.vue?vue&type=script&lang=js"
export * from "./IssueBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__